export function OutlineLegalFileIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5196 19.0054C18.6251 19.0054 19.5213 18.1092 19.5213 17.0037C19.5213 15.8982 18.6251 15.002 17.5196 15.002C16.414 15.002 15.5178 15.8982 15.5178 17.0037C15.5178 18.1092 16.414 19.0054 17.5196 19.0054Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
      <path
        d="M18.0188 19.002L19.0173 22.0022"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
      <path
        d="M17.0204 19.002L16.0171 22.0022"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
      <path
        d="M13.0169 21.0012H5.9844C4.88033 21.0012 3.98267 20.1036 3.98267 18.9995V5.00174C3.98267 3.89286 4.88033 3 5.9844 3H12.22C12.7529 3 13.2617 3.21121 13.6361 3.58564L17.4668 7.4163C17.8412 7.79073 18.0524 8.29957 18.0524 8.8276V12.0006"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
      <path
        d="M12.052 3V7.2867C12.052 8.23236 12.8201 9.00041 13.7657 9.00041H18.0524"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
      <path d="M7.01636 12H13.0168" stroke={stroke} strokeWidth={strokeWidth} />
      <path d="M7.01636 15.998H13.0168" stroke={stroke} strokeWidth={strokeWidth} />
    </svg>
  );
}
